function PivotIndicator(props) {
    return null;
}
PivotIndicator.symbol = 'PivotIndicator';

export { PivotIndicator as default };
